import React from 'react';
import { MessageSquare, Building2, LayoutGrid, Globe } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const MasterCard = ({ icon: Icon, title, description, onOpen }) => {
  return (
    <div className="dash-glass-card" style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 16 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
        <div style={{ 
          width: 48, height: 48, borderRadius: 12, 
          background: 'rgba(var(--app-primary-color-rgb), 0.12)', 
          border: '1px solid rgba(var(--app-primary-color-rgb), 0.2)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: 'var(--accent-primary)'
        }}>
          <Icon size={24} />
        </div>
      </div>
      
      <div>
        <h3 style={{ margin: '0 0 8px 0', fontSize: 18, fontWeight: 700, color: 'var(--text-primary)' }}>{title}</h3>
        <p style={{ margin: 0, fontSize: 13, color: 'var(--text-secondary)', lineHeight: 1.5, minHeight: 40 }}>{description}</p>
      </div>

      <div style={{ 
        marginTop: 'auto', 
        paddingTop: 16, 
        borderTop: '1px solid var(--border-light)', 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center' 
      }}>
        <div style={{ display: 'flex', gap: 8 }}>
          <button 
            onClick={onOpen}
            style={{ 
            background: 'var(--input-bg)', 
            color: 'var(--text-primary)', 
            border: '1px solid var(--border-light)', 
            padding: '6px 16px', 
            borderRadius: 6, 
            fontSize: 13, 
            fontWeight: 600, 
            cursor: 'pointer' 
          }}>Open</button>
        </div>
      </div>
    </div>
  );
};

const AllMasters = () => {
  const navigate = useNavigate();
  
  const masters = [
    {
      icon: MessageSquare,
      title: 'Quick Messages Master',
      description: 'Manage template message alerts for instant communication with monitored workstation clients.',
      onOpen: () => navigate('/masters/quick-messages')
    },
    {
      icon: Building2,
      title: 'Department Master',
      description: 'Create, update and structure organizational departments, configure color tags and heads.',
      onOpen: () => navigate('/masters/departments')
    },
    {
      icon: LayoutGrid,
      title: 'Room & Lab Master',
      description: 'Manage physical office rooms, labs and auto-generate interactive computer position grids.',
      onOpen: () => navigate('/masters/rooms')
    },
    {
      icon: Globe,
      title: 'Website Block Master',
      description: 'Setup domain filtering rules, categories block list and active directory policies.',
      onOpen: () => navigate('/masters/blocks')
    }
  ];

  return (
    <div style={{ padding: '24px', flex: 1, overflowY: 'auto' }}>
      <div style={{ marginBottom: 32 }}>
        <h1 style={{ margin: '0 0 4px 0', fontSize: 24, fontWeight: 700, color: 'var(--text-primary)' }}>ALL Masters</h1>
        <p style={{ margin: 0, fontSize: 14, color: 'var(--text-secondary)' }}>Manage all configurations and enterprise setting rules</p>
      </div>

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', 
        gap: 24 
      }}>
        {masters.map((master, index) => (
          <MasterCard key={index} {...master} />
        ))}
      </div>
    </div>
  );
};

export default AllMasters;
